import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const predictionProgressManager = {
  getPredictionProgressData(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default predictionProgressManager;
